import React, { useCallback, useState } from 'react';
import { Button } from '@totango-app-team/ui-shared-components';
import PropTypes from 'prop-types';

import { ERROR_TYPES } from '../utils/api';

import CheckYourEmail from './check-your-email';

const Content = ({ errorType, onResendLink, signupEmail, signupDomain }) => {
	const [didResendLink, setDidResendLink] = useState(false);
	const onResendLinkClick = useCallback(() => {
		onResendLink();
		setDidResendLink(true);
	}, [onResendLink]);
	const reload = useCallback(() => {
		window.location.reload();
	}, []);

	if (errorType === ERROR_TYPES.AUTHENTICATION || errorType === ERROR_TYPES.DOMAIN) {
		return didResendLink ? (
			<CheckYourEmail email={signupEmail} isActiveStep />
		) : (
			<>
				<h2 className="signup-error-title" align="center">
					Link Expired
				</h2>
				<div className="signup-error-caption" align="center">
					The link we&apos;ve sent is no longer valid.
				</div>
				{!errorType === ERROR_TYPES.DOMAIN && (
					<div className="signup-error-button" align="center">
						<Button onClick={onResendLinkClick} color="primary" variant="contained" size="large">
							{'Get Verification Link Again'}
						</Button>
					</div>
				)}
			</>
		);
	}
	if (errorType === ERROR_TYPES.DOMAIN_TAKEN) {
		return (
			<div className="signup-error-caption" align="center">
				{`The domain ${signupDomain} is already associated with another Totango service`}
			</div>
		);
	}
	if (errorType === ERROR_TYPES.USERNAME_TAKEN) {
		return (
			<div className="signup-error-caption" align="center">
				{`This email ${signupEmail} is already associated with another Totango service`}
			</div>
		);
	}
	return (
		<>
			<div className="signup-error-caption" align="center">
				Something went wrong
				<br />
				<br />
				{'Please '}
				<span className="link" onClick={reload}>
					reload the page
				</span>
				{' to try again'}
			</div>
		</>
	);
};

const SignupError = props => (
	<div className="signup-error">
		<img src="/img/logo/totango-dark.png" className="totango-logo" alt="Totango" />
		<Content {...props} />
	</div>
);

SignupError.defaultProps = {
	errorType: '',
	signupEmail: '',
	signupDomain: '',
};

SignupError.propTypes = {
	errorType: PropTypes.oneOf(Object.keys(ERROR_TYPES)),
	onResendLink: PropTypes.func.isRequired,
	signupEmail: PropTypes.string,
	signupDomain: PropTypes.string,
};

export default SignupError;
